export default "__VITE_ASSET__BBoY3z7z__"